export { isBackEvent };

/**
 * Return true if passed event match to "Back" button tap
 * @param {{event_type: string, event_code: string}} event
 * @example payload.action
 * {
    "event_type": "system" ,
    "event_code": "back"
  }
 * @example message
{
  "type": "interactive:action",
  "data": {
    "event_type": "system",
    "event_code": "back",
  }
}
 */
function isBackEvent(event) {
  const { event_type, event_code } = event;

  return event_type === 'system' && event_code === 'back';
}
